import React from "react"
import PropTypes from 'prop-types';
import {Col} from "reactstrap";

export default class Entry extends React.Component {

  render() {
    const {timestamp, title, status} = this.props
    return <li>
      <span title={timestamp}>{this.props.children}</span>
      </li>
  }
}

Entry.propTypes = {
  timestamp: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  status: PropTypes.oneOf(['success', 'warning', 'danger'])
};

Entry.defaultProps = {
  status: 'success'
};


// WEBPACK FOOTER //
// ./src/components/Verification/Timeline/SubEntry.js